<template>
  <div class="page-view">
    <img :src="$route.query.url" alt=""  @click="$router.go(-1)" />
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.page-view {
  width: 100%;
  height: 100%;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
